var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11 22.955V15H8v-3h3v-2c0-3.02 1.056-4 4-4h2v3h-2c-1 0-1 .287-1 1v2h3v3h-3v7.819c5.12-.94 9-5.427 9-10.819 0-6.075-4.925-11-11-11S1 5.925 1 12c0 5.738 4.394 10.45 10 10.955Z","clipRule":"evenodd"}));
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":"Facebook"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
